const { Component, Fragment } = wp.element;

export class CheckFields extends Component {

  constructor( props ) {
    super( props );
    this.term_ids  = this.props.selectedIds.map( ( id ) => {
      return 'number' === typeof id ? id.toString() : id;
    });
    this.toggleAll = this.toggleAll.bind( this );
    this.toggle    = this.toggle.bind( this );
  }

  toggleAll( e ) {
    const checked = e.target.checked;
    this.term_ids = e.target.checked ? this.props.terms.map( term => {
      return 'number' === typeof term.id ? term.id.toString() : term.id;
    } ) : [];
    this.props.handleChange( this.term_ids );
  }

  toggle( e ) {
    const id = e.target.value;
    if ( e.target.checked ) {
      // Add.
      if ( -1 === this.term_ids.indexOf( id ) ) {
        this.term_ids.push( id );
      }
    } else {
      // Remove.
      this.term_ids = this.term_ids.filter( ( term_id ) => {
        return term_id !== id;
      } );
    }
    this.props.handleChange( this.term_ids );
  }


  render() {
    return(
      <Fragment>
        <div className="form-check field">
          <label>
            <input type="checkbox" name="check" onChange={ this.toggleAll }
                   className="checkbox-option"/> <span
            className="label-text">全て</span>
          </label>
        </div>
        {this.props.terms.map((term) => {
          const termId = 'number' === typeof term.id ? term.id.toString() : term.id;
          return (
            <div className="form-check field" ref={term.id}>
              <label>
                <input type="checkbox" checked={ -1 !== this.props.selectedIds.indexOf( termId ) } value={term.id}
                       className="checkbox-option" onChange={ this.toggle }/> <span
                className="label-text">{term.label}</span>
              </label>
            </div>
          );
        })}
      </Fragment>
    );
  }

}


